import { Box, Image, Stack, Text, VStack } from "@chakra-ui/react";
import { FaArrowLeft, FaArrowRight, FaRegCirclePlay } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Logo from "../../../assets/colorLogo.png";
const PendingCourses = () => {
  const { pendingCourses } = useSelector((state) => state.studentCourses);

  const navigate = useNavigate();
  function SampleNextArrow(props) {
    const { style, onClick } = props;
    return (
      <div
        // className={className}
        style={{
          ...style,
          width: "30px",
          right: "-35px",
          position: "absolute",
          top: "0",
          zIndex: "10000000",
          height: "92%",
          background: "#f2f2f2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          opacity: "70%",
        }}
        onClick={onClick}
      >
        <FaArrowRight size={22} />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { style, onClick } = props;
    return (
      <div
        // className={className}
        style={{
          ...style,
          display: "block",
          width: "30px",
          position: "absolute",
          left: "-35px",
          top: "0%",
          zIndex: "10000000",
          height: "92%",
          background: "#f2f2f2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          opacity: "70%",
        }}
        onClick={onClick}
      >
        <FaArrowLeft size={22} />
      </div>
    );
  }
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    variableWidth: true,
    appendDots: (dots) => (
      <div
        style={{
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "16px",
          height: "16px",
          background: "#8196df",
          borderRadius: "50%",
        }}
      ></div>
    ),

    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <VStack gap={6} h="100%" w="100%" alignItems="flex-start" my={10}>
      <Text
        fontSize="32px"
        color="main_1"
        textAlign="center"
        fontWeight="700"
        textTransform="uppercase"
        w="100%"
      >
        Pending Courses
      </Text>
      {pendingCourses?.length == 0 ? (
        <Stack justifyContent="center" alignItems="center" w="100%">
          <Text fontSize="18px">No pending courses available </Text>
        </Stack>
      ) : (
        <Slider {...settings} className="slider">
          {pendingCourses?.map((data, index) => {
            return (
              <Box
                key={index}
                w="350px !important"
                bg="blackAlpha.200"
                borderRadius={16}
                display="flex !important"
                flexDirection="column"
                role="group"
                cursor="pointer"
                _hover={{
                  transition: "500ms ease-in-out",
                }}
              >
                <Box overflow="hidden">
                  <Image
                    src={Logo}
                    alt="Green double couch with wooden legs"
                    borderTopRadius="lg"
                    _groupHover={{
                      transform: "scale(1.2)",
                      transition: "500ms ease-in-out",
                    }}
                  />
                </Box>
                <Stack spacing="2" p={5}>
                  <Text color="main_1" fontSize={20} fontWeight={600}>
                    {data?.name}
                  </Text>
                  <Text color="main_1" fontSize={16}>
                    {data?.subjects?.[0]?.name}
                  </Text>

                  <Stack flexDirection="row" alignItems="center" gap={2}>
                    <FaRegCirclePlay color="#8196df" size={20} />{" "}
                    <Text mt="-1px !important">0 Lessons</Text>
                  </Stack>
                </Stack>
              </Box>
            );
          })}
        </Slider>
      )}
    </VStack>
  );
};

export default PendingCourses;
